import { isBoom } from '@hapi/boom'
import { QueryClient } from 'react-query'
import { isPrivateRoute, redirectToLogin } from './auth'

export function getQueryClient(router) {
  const { route: currentRoute } = router.state ?? {}

  return new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        refetchInterval: false,
        refetchOnMount: false,
        retry: (failureCount, error) => {
          if (isBoom(error, 401)) {
            return false
          }
          return failureCount < 4
        },
        onError: (error) => {
          if (isBoom(error, 401) && isPrivateRoute(currentRoute)) {
            if (typeof window !== 'undefined') {
              redirectToLogin(window.location.pathname)
            }
          }
        },
      },
      mutations: {
        onError: (error) => {
          if (isBoom(error, 401)) {
            redirectToLogin(window.location.pathname)
          }
        },
      },
    },
  })
}
